import { CommonModule } from "@angular/common";
import { Component, inject } from "@angular/core";
import { UiLibraryModule } from "@template-ui/template-ui.module";
import { EzGridDsConfig, PanelHeaderConfig } from "@template-ui/types";
import { ColDef } from "ag-grid-community";
import { PlatformAccessAdminService } from "./platform-access-admin.service";

@Component({
  selector: "phms-platform-access-role-permission-catalog",
  imports: [CommonModule, UiLibraryModule],
  templateUrl: "./platform-access-role-permission-catalog.component.html",
  styleUrl: "./platform-access-admin.component.scss",
})
export class PlatformAccessRolePermissionCatalogComponent {
  private readonly platformAccessAdminService = inject(PlatformAccessAdminService);

  readonly pagePanelSubtitle = "";
  readonly roleCatalogGridConfig: EzGridDsConfig = this.buildRoleCatalogGridConfig();
  readonly permissionCatalogGridConfig: EzGridDsConfig = this.buildPermissionCatalogGridConfig();
  readonly roleCatalogPanelHeaderConfig: PanelHeaderConfig = this.buildRoleCatalogPanelHeaderConfig();
  readonly permissionCatalogPanelHeaderConfig: PanelHeaderConfig = this.buildPermissionCatalogPanelHeaderConfig();

  private buildRoleCatalogGridConfig(): EzGridDsConfig {
    return {
      datasourceId: "platformRoles",
      bindings: [
        {
          bindingType: "READ",
          endpoint: this.platformAccessAdminService.getRolesODataEndpoint(),
          protocol: "GET_ODATA",
        },
      ],
      colDefs: this.buildRoleCatalogColumnDefs(),
    };
  }

  private buildPermissionCatalogGridConfig(): EzGridDsConfig {
    return {
      datasourceId: "platformPermissions",
      bindings: [
        {
          bindingType: "READ",
          endpoint: this.platformAccessAdminService.getPermissionsODataEndpoint(),
          protocol: "GET_ODATA",
        },
      ],
      colDefs: this.buildPermissionCatalogColumnDefs(),
    };
  }

  private buildRoleCatalogColumnDefs(): ColDef[] {
    return [
      { field: "name", headerName: "Role", flex: 1, minWidth: 190 },
      { field: "code", headerName: "Code", flex: 1, minWidth: 170 },
      { field: "description", headerName: "Description", flex: 2, minWidth: 260 },
      {
        field: "isSystem",
        headerName: "Built-in",
        width: 110,
        valueFormatter: ({ value }) => value ? "Yes" : "No",
      },
      {
        field: "isActive",
        headerName: "Active",
        width: 115,
        valueFormatter: ({ value }) => value ? "Yes" : "No",
      },
    ];
  }

  private buildPermissionCatalogColumnDefs(): ColDef[] {
    return [
      { field: "name", headerName: "Permission", flex: 1, minWidth: 210 },
      { field: "code", headerName: "Code", flex: 1, minWidth: 210 },
      { field: "description", headerName: "Description", flex: 2, minWidth: 280 },
      {
        field: "isActive",
        headerName: "Active",
        width: 115,
        valueFormatter: ({ value }) => value ? "Yes" : "No",
      },
    ];
  }

  private buildRoleCatalogPanelHeaderConfig(): PanelHeaderConfig {
    return {
      panelHeaderTitle: "Roles",
      titleClickToReload: true,
    };
  }

  private buildPermissionCatalogPanelHeaderConfig(): PanelHeaderConfig {
    return {
      panelHeaderTitle: "Permissions",
      titleClickToReload: true,
    };
  }
}
